import { getCustomerSupportAutoReplyConfig } from 'Api/endpoints/CustomerSupportAutoReply';
import { postCustomerSupportChatAutoReply } from 'Api/endpoints/CustomerSupportChat';
import { useError } from 'Api/hooks/useError';
import { useCallback, useEffect, useState } from 'react';

const useFaq = () => {
  const { showErrorPopup } = useError();
  const [faq, setFaq] = useState([]);

  const getFaqList = useCallback(async () => {
    const result = await getCustomerSupportAutoReplyConfig();
    if (result.err) {
      showErrorPopup({ text: result.err.response.data.message });
      return;
    }
    setFaq(result.items);
  }, [showErrorPopup]);

  useEffect(() => {
    getFaqList();
  }, [getFaqList]);

  const postFaq = useCallback(
    async (autoReplyId, callback) => {
      try {
        const result = await postCustomerSupportChatAutoReply({ autoReplyId });
        if (result.err) {
          showErrorPopup({ text: result.err.response.data.message });
          return;
        }
        callback && callback();
      } catch (error) {
        console.log(error);
      }
    },
    [showErrorPopup]
  );

  return { faq, postFaq };
};

export default useFaq;
